import { call, put, takeEvery } from 'redux-saga/effects';
import { getUserInfo } from '../../requests/get_content_request';
import { getUserInfoSuccess, getUserInfoFailure } from '../actions/user_info.actions';
import { USER_INFO_REQUEST } from '../constants/user_info.constants';

function* getUserInfoRequest({ param }) {
    const data = yield call(getUserInfo, param);
    data
        ? yield put(getUserInfoSuccess(data))
        : yield put(getUserInfoFailure('Something gone wrong'));
}

export default function* userInfoSaga() {
    yield takeEvery(USER_INFO_REQUEST, getUserInfoRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/user_info.saga.js